import { environment, region } from '@microbt/shared';
import gdp from 'gio-webjs-sdk';
import gioHybridAdapter from 'gio-webjs-sdk/plugins/gioHybridAdapter';
import { isAndroid, isIOS } from './env';
interface GdpTrackParams {
  setup?: string;
  state?: string;
  [key: string]: any;
}

const isOversea = region() !== 'cn';

const initGdp = () => {
  if (isOversea) {
    return;
  }
  // @see https://growingio.github.io/growingio-sdk-docs/docs/webjs/integrate
  const dataSourceId = environment() === 'prod' ? 'ad15bfd0f5cbefd5' : 'a6ab40ba415da54a';
  const accountId = environment() === 'prod' ? 'b857b438652a87dc' : 'b5cb70c3f1beb836';
  const packageName = isIOS ? 'com.superacme.shenmou' : isAndroid ? 'com.superacme.cinmoore' : '';

  gdp('registerPlugins', [gioHybridAdapter]);
  gdp('init', accountId, dataSourceId, {
    packageName,
    serverUrl: 'https://collect.superacme.com',
    usePlugin: true,
  });
  gdp('getDeviceId', (deviceId: string) => {
    console.log('deviceId:=========', deviceId);
  });
};
initGdp();
export const gdpTrack = (event: string, params: GdpTrackParams = {}) => {
  if (isOversea) {
    return;
  }
  console.log(event, {
    ...params,
  });
  gdp('track', event, {
    ...params,
  });
};
